import { isDefined } from "@omni/utils/helper.utils";
import { Ref } from "react";

import { StoreDirectionsInput } from "./components/input/storeDirectionsInput.container";
import { StoreDirectionsMap } from "./components/map/storeDirectionsMap.container";
import { StoreDirectionsResult } from "./components/result/storeDirectionsResult.container";
import { useStoreDirectionsContext } from "./storeDirections.context";

import "./storeDirections.scss";

type StoreDirectionsComponentProps = {
    ref: Ref<HTMLDivElement>;
};

export const StoreDirectionsComponent = ({
    ref
}: StoreDirectionsComponentProps) => {
    const { origin } = useStoreDirectionsContext();

    return (
        <div className={"store-directions"}>
            <StoreDirectionsMap ref={ref} />
            <div className={"store-directions__controls"}>
                {!isDefined(origin) && <StoreDirectionsInput />}
                {isDefined(origin) && <StoreDirectionsResult />}
            </div>
        </div>
    );
};
